import { observer } from 'mobx-react';
import React from 'react';

const styles = require('./guidance-category.css');

interface GuidanceCategoryProps {
  title: string;
  content?: JSX.Element;
}

@observer
export class GuidanceCategory extends React.Component<GuidanceCategoryProps> {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.title}>{this.props.title}</div>
        <div className={styles.content}>{this.props.content ? this.props.content : undefined}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/guidance-category/guidance-category.tsx